<template>
  <div class="survey-form" v-if="form">
    <h1 class="survey-form__title">{{ form.title }}</h1>
    <p v-if="form.description" v-html="form.description" class="survey-form__description"></p>
    <iframe class="survey-form__iframe" :src="form.url" :height="form.height">
    </iframe>
  </div>
</template>
<script>
export default {
  data() {
    return {
      form: {},
      formUrl: "",
    };
  },
  methods: {
    async getForm() {
      try {
        const params = new URLSearchParams({
          ...(this.$route.query.access && { access: this.$route.query.access })
        });
        const { data } = await this.$axios({
          method: "GET",
          url: `/api/survey-${this.$route.params.id}/`,
          params
        });
        const parser = new DOMParser();
        const doc = parser.parseFromString(data.iframe || "", "text/html");
        const iframe = doc.querySelector("iframe");

        if (!iframe || !iframe.src) {
          throw new Error("Invalid iframe format in response");
        }

        const height = iframe.height ?? "1000px";

        const searchParams = new URLSearchParams(this.$route.query);

        const queryString = searchParams.toString() ? `&${searchParams.toString()}` : '';


        this.form = {
          ...data,
          height,
          url: `${iframe.src}${queryString}`
        };
      } catch (error) {
        console.error("Failed to load survey:", error);
      }

    },
  },
  mounted() {
    this.getForm();
  },
};
</script>
<style lang="scss" scoped>
.survey-form {
  width: 1216px;
  margin: 64px auto;

  @media screen and (max-width: 1220px) {
    margin: 20px auto 0;
    padding: 0 76px;
  }

  @media screen and (max-width: 767px) {
    margin: 0 auto;
    padding: 0 16px;
  }

  &__title {
    font-family: "Roboto Slab", sans-serif;
    font-style: normal;
    font-weight: 400;
    font-size: 42px;
    line-height: 48px;
    color: #1f1f1f;

    @media screen and (max-width: 767px) {
      font-size: 21px;
      line-height: 26px;
    }
  }

  &__description {
    font-family: "Roboto Slab", sans-serif;
    font-style: normal;
    font-weight: 400;
    font-size: 20px;
    line-height: 22px;
    color: #656969;
    margin-top: 20px;

    @media screen and (max-width: 767px) {
      font-size: 16px;
      line-height: 16px;
      width: 350px;
    }
  }

  &__iframe {
    margin-top: 40px;
    width: 100%;
    overflow: hidden;

    @media screen and (max-width: 767px) {
      width: 340px;
    }
  }
}
</style>

<style lang="scss">
.survey-form__description {
  & h1 {
    font-size: 2.5rem;
    font-weight: bold;
    line-height: 120%;
  }

  & h2 {
    font-size: 2.3rem;
    font-weight: bold;
    line-height: 120%;
  }

  & h3 {
    font-size: 2.1rem;
    font-weight: bold;
    line-height: 120%;
  }

  & h4 {
    font-size: 1.9rem;
    font-weight: bold;
    line-height: 120%;
  }

  & h5 {
    font-size: 1.7rem;
    font-weight: bold;
    line-height: 120%;
  }

  & h6 {
    font-size: 1.5rem;
    font-weight: bold;
    line-height: 120%;
  }

  & ul,
  & ol {
    margin-left: 1em;

    & li {
      &:not(:last-child) {
        margin-bottom: 8px;
      }
    }
  }

  & ul {
    list-style-type: disc;
  }

  & ol {
    list-style-type: decimal;
  }

  & i {
    font-style: italic;
  }

  & b {
    font-weight: bold;
  }
}
</style>
